/* unplugin-vue-components disabled */import { render } from "./CreateAudioFromText.vue?vue&type=template&id=d47e1068&scoped=true&ts=true"
import script from "./CreateAudioFromText.vue?vue&type=script&lang=ts"
export * from "./CreateAudioFromText.vue?vue&type=script&lang=ts"

import "./CreateAudioFromText.vue?vue&type=style&index=0&id=d47e1068&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d47e1068"]])

export default __exports__